import { inject } from 'vue'
import {
  agencyStructureKey,
  type AgencyStructureService
} from '@gat-ship/types/injection-keys'

/**
 * Injects the agency-structure service that the admin shell provides (via
 * `AgencyStructureProvider`) around the settings route subtree. The per-setting
 * cards read the structure tree through the `@gat-ship/types` contract rather
 * than importing `@gat-ship/agency`, keeping `@gat-ship/agency-settings` free of an
 * agency dependency.
 *
 * Throws when no provider is mounted above — an empty inherit list would
 * otherwise be a silent, type-invisible bug.
 */
export function useAgencyStructureContext(): AgencyStructureService {
  const ctx = inject(agencyStructureKey)
  if (!ctx) {
    throw new Error(
      'AgencySettings: no agencyStructureKey provider mounted above'
    )
  }
  return ctx
}
